import React, { useEffect } from 'react'
import { Alert, Button, Collapse, Empty, Flex, Form, List, Select, Space } from 'antd'
import PatternIcon from '../../../../../components/common/PatternIcon'
import { getQuestionCategories } from '../../../../../hooks/useRubricContext'

const CompareWithLmsForm = ({ questions = [], lmsQuestions = [], onSubmit, loading, error }) => {
    const [form] = Form.useForm()
    const formValues = Form.useWatch([], form) // don't remove this, it is to trigger re-render

    useEffect(() => {
        const values = {}

        questions.forEach(question => {
            values[`question-${question.id}`] = question.lmsId

            getQuestionCategories(question).forEach(category => {
                values[`category-${category.id}`] = category?.lmsId
            })
        })

        form.setFieldsValue(values)
    }, [lmsQuestions, questions, form])

    const handleSubmit = values => {
        const structuredData = questions.map(question => {
            return {
                id: question.id,
                lmsId: values[`question-${question.id}`],
                categories: getQuestionCategories(question).map(category => {
                    return {
                        id: category.id,
                        lmsId: values[`category-${category.id}`],
                    }
                }),
            }
        })
        onSubmit(structuredData)
    }

    const lmsQuestionOptions = lmsQuestions.map(lmsQuestion => ({
        label: lmsQuestion.content,
        value: lmsQuestion.id,
    }))

    const questionCollapseItems = questions.map(question => {
        const questionValue = formValues ? formValues[`question-${question.id}`] : null
        const lmsQuestion = lmsQuestions?.find(lmsQuestion => lmsQuestion.id === (questionValue || question.lmsId))

        const lmsCategoryOptions = lmsQuestion?.categories.map(lmsCategory => ({
            label: lmsCategory.name,
            value: lmsCategory.id,
        }))

        const categoryItems = getQuestionCategories(question).map(category => {
            return {
                ...category,
                lmsId: lmsQuestion?.categories.find(lmsCategory => lmsCategory.id === category.id)?.lmsId,
            }
        })

        return {
            key: question.id,
            label: question.name || question.content,
            forceRender: true,
            extra: (
                <Form.Item name={`question-${question.id}`} noStyle>
                    <Select
                        options={lmsQuestionOptions}
                        popupMatchSelectWidth={false}
                        onClick={event => event.stopPropagation()}
                        placeholder='Select corresponding LMS question if any'
                        showSearch
                        optionFilterProp='label'
                    />
                </Form.Item>
            ),
            children: (
                <Flex vertical>
                    <List
                        dataSource={categoryItems}
                        size='small'
                        locale={{ emptyText: <Empty description='There are no categories' /> }}
                        renderItem={item => {
                            return (
                                <List.Item key={item.id}>
                                    <Flex justify='space-between' align='center' className='f-width'>
                                        <Space>
                                            <PatternIcon id={item.id} colorId={item.colorId} showId={false} />{' '}
                                            {item.name}
                                        </Space>
                                        <Form.Item name={`category-${item.id}`} noStyle>
                                            <Select
                                                options={lmsCategoryOptions}
                                                popupMatchSelectWidth={false}
                                                onClick={event => event.stopPropagation()}
                                                placeholder='Select corresponding LMS category if any'
                                                showSearch
                                                optionFilterProp='label'
                                            />
                                        </Form.Item>
                                    </Flex>
                                </List.Item>
                            )
                        }}
                    />
                </Flex>
            ),
        }
    })

    return (
        <Form
            form={form}
            name='test-form'
            onFinish={handleSubmit}
            layout='vertical'
            requiredMark={false}
            validateTrigger={['onBlur', 'onSubmit']}
        >
            <Collapse size='small' bordered={false} items={questionCollapseItems} className='mb-16' />
            {error && <Alert message={error} type='error' showIcon closable />}
            <Flex justify='end'>
                <Form.Item>
                    <Button type='primary' htmlType='submit' loading={loading}>
                        Update relationships
                    </Button>
                </Form.Item>
            </Flex>
        </Form>
    )
}

export default CompareWithLmsForm
